<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.edit_workingHours") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #266db0">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="submitForm">
        <div class="row">
          <v-container>
            <v-row class="mb-6" v-if="boxes.length === 0">
              <v-btn @click="addBox">
                <!-- <i class="fas fa-plus"></i> -->
                <base-button
                  class="p-3 fs-5 fw-bold"
                  :btnText="$t('BUTTONS.add')"
                  style="color: #266db0"
                  styleType="btn"
                />
              </v-btn>
            </v-row>
            <v-row
              v-for="(box, dayIndex) in boxes"
              :key="dayIndex"
              align="center"
            >
              <v-col cols="1" class="text-right">
                <v-btn icon color="primary" @click="addBox">
                  <i class="fas fa-plus"></i>
                </v-btn>

                <v-btn
                  icon
                  color="red"
                  v-if="boxes.length > 1"
                  @click="removeBox(dayIndex)"
                >
                  <i class="fas fa-minus"></i>
                </v-btn>
              </v-col>
              <base-select-input
                col="11"
                :optionsList="weekdays_selection"
                :placeholder="$t('PLACEHOLDERS.day')"
                v-model="box.day"
                required
              />
              <v-row v-for="(period, index) in box.periods" :key="index">
                <v-col cols="2" class="text-right">
                  <v-btn icon color="primary" @click="addPeriod(dayIndex)">
                    <i class="fas fa-plus"></i>
                  </v-btn>

                  <v-btn
                    icon
                    color="red"
                    v-if="box.periods.length > 1"
                    @click="removePeriod(dayIndex, index)"
                  >
                    <i class="fas fa-minus"></i>
                  </v-btn>
                </v-col>
                <v-col cols="5">
                  <base-input
                    type="time"
                    :placeholder="$t('PLACEHOLDERS.from')"
                    v-model="period.from"
                    required
                  />
                </v-col>

                <v-col cols="5">
                  <base-input
                    type="time"
                    :placeholder="$t('PLACEHOLDERS.to')"
                    v-model="period.to"
                    required
                  />
                </v-col>
              </v-row>

              <v-divider class="my-4 border-2"></v-divider>
            </v-row>
          </v-container>
          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "WorkingHoursProviders",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      data: {},
      boxes: [
        {
          day: "",
          periods: [],
        },
      ],
      selectedDays: [],
    };
  },

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
    }),
    weekdays_selection() {
      const selectedValues = this.boxes.map((day) => day.day?.id);
      return [
        { id: 2, name: this.$t("days.Sunday"), value: "sunday" },
        { id: 3, name: this.$t("days.Monday"), value: "monday" },
        { id: 4, name: this.$t("days.Tuesday"), value: "tuesday" },
        {
          id: 5,
          name: this.$t("days.Wednesday"),
          value: "wednesday",
        },
        { id: 6, name: this.$t("days.Thursday"), value: "thursday" },
        { id: 7, name: this.$t("days.Friday"), value: "friday" },
        { id: 1, name: this.$t("days.Saturday"), value: "saturday" },
      ].filter((day) => !selectedValues.includes(day.id));
    },
  },

  methods: {
    onDayChange(selectedDay) {
      this.filterAndSelectDay(selectedDay);
    },
    filterAndSelectDay(dayToSelect) {
      console.log("datyyy", dayToSelect);

      const index = this.boxes.findIndex((box) => box.day?.id === dayToSelect);
      if (index !== -1) {
        // Add to selectedDays array
        this.selectedDays.push(this.boxes[index].day);

        // Remove from boxes
        this.boxes.splice(index, 1);
      }
    },
    addBox() {
      this.boxes.push({
        day: "",
        periods: [
          {
            from: "",
            to: "",
          },
        ],
      });
    },
    addPeriod(index) {
      this.boxes[index].periods.push({
        from: "",
        to: "",
      });
    },
    removeBox(index) {
      if (this.boxes.length > 1) {
        this.boxes.splice(index, 1);
      }
    },
    removePeriod(dayIndex, index) {
      if (this.boxes[dayIndex].periods.length > 1) {
        this.boxes[dayIndex].periods.splice(index, 1);
      }
    },
    async submitForm() {
      const REQUEST_DATA = new FormData();
      this.boxes?.map((ele, index) => {
        if (ele.day) {
          REQUEST_DATA.append(`days[${index}][is_active]`, 1);
        }
        if (ele.day) {
          REQUEST_DATA.append(`days[${index}][day_id]`, ele.day.id);
        }
        ele.periods.forEach((period, periodIndex) => {
          if (period.from) {
            REQUEST_DATA.append(
              `days[${index}][times][${periodIndex}][from]`,
              period.from
            );
          }
          if (period.to) {
            REQUEST_DATA.append(
              `days[${index}][times][${periodIndex}][to]`,
              period.to
            );
          }
        });
      });
      try {
        await this.$axios({
          method: "POST",
          url: `providers/update-times/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/providers/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    // start show data
    async showWorkingDays() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `providers/${this.$route.params.id}`,
        });

        console.log("provider", res);

        this.boxes = res.data.data.Provider.working_days?.map((ele) => ({
          day: {
            id: ele.day_id,
            name: ele.day_name,
            value: ele.day_name,
          },
          periods: ele.periods,
        }));

        // Then, optionally update selectedDays if needed
        this.selectedDays = this.boxes.map((box) => box.day);
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data
  },
  created() {
    // Start:: Fire Methods
    this.showWorkingDays();
    // this.filterAndSelectDay();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
.theme--light.v-divider {
  border-color: #0d6efd;
}
</style>
